/* eslint-disable max-len */
import React from 'react';

import css from './style.module.scss';

const PrimaryIconSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 285 285">
    <defs>
      <mask id="as-spinner-s-mask" fill="#fff" x="-20%" y="-20%" width="140%" height="150%">
        <path d="M135.57 79.04c24.72-15.45 52.96-5.33 73.66 27.8a128.58 128.58 0 0 1 14.25 31.2c1.1 3.66 2.2 8.74 3.3 15.26a4.93 4.93 0 0 1-3.73 5.63L201.37 164a4.96 4.96 0 0 1-5.95-3.7c-.05-.18-1.28-9.73-1.79-12.37-1.67-8.6-4.4-16.27-10.16-25.48-9.88-15.8-19.12-19.52-26.92-14.65-18.41 11.5 34.5 72.17-9.14 99.44-21.07 13.16-48.57 9.75-71.66-27.2a159.3 159.3 0 0 1-14.32-29.45c-.99-2.73-2.09-6.37-3.3-10.93a4.93 4.93 0 0 1 3.51-6.04l21.38-4.8a4.96 4.96 0 0 1 5.86 3.5c1.68 5.98 3 10.33 3.95 13.05a82.62 82.62 0 0 0 8.34 17.4c11.23 17.98 19.62 19.21 25.6 15.48 18.24-11.4-35.66-71.44 8.8-99.22z" />
      </mask>
    </defs>
    <g fill="none" fillRule="evenodd">
      <g mask="url(#as-spinner-s-mask)" className={css.asSpinnerEyes}>
        <path
          stroke="#2C435C"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="30"
          d="M76.87 146.57c4.01 10.03 7.5 19.32 14.42 28.6 6.45 8.78 10.9 14.25 23.64 20.98 16.62 2.97 25.64-1.76 32.16-13.31 4.6-8.6 2.46-22.69-6.44-42.26"
          className={css.asSpinnerLeftEye}
        />
        <path
          stroke="#2C435C"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="30"
          d="M208.2 145.32c-2.94-10.4-5.45-20-11.35-29.95-5.5-9.41-9.36-15.32-21.32-23.35-16.39-7.2-27.87-3.64-35.56 7.17-5.48 8.07-4.87 22.46 1.83 43.17"
          className={css.asSpinnerRightEye}
        />
      </g>
      <path
        fill="#2192EF"
        d="M63.57 223.04c24.72 17.58 50.63 27.41 76.01 27.41 25.23 0 51-9.77 75.77-27.25a4.51 4.51 0 0 1 6.86 2.2l7.64 21.9a6 6 0 0 1-2.36 6.98l-1.13.74c-27.64 17.92-56.95 28.09-86.78 28.09-30.24 0-59.95-10.41-87.78-28.72l-.95-.62a6 6 0 0 1-2.33-6.96l7.38-21.32a5.03 5.03 0 0 1 7.67-2.45z"
        className={css.asSpinnerSmile}
      />
    </g>
  </svg>
);

export default PrimaryIconSvg;
